import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const FadeIn = ({ children, delay = 0, y = 28, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const MaskLines = ({ lines, className = "", lineClassName = "", delay = 0, as: Tag = "span" }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.1em] -mb-[0.1em]">
        <motion.span
          className={`block ${lineClassName}`}
          initial={{ y: "115%" }}
          animate={{ y: 0 }}
          transition={{ duration: 1.15, delay: delay + i * 0.13, ease: EASE }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);

export const ParallaxImage = ({ src, alt, className = "", speed = 0.06, eager = false }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [`-${speed * 100}%`, `${speed * 100}%`]);
  return (
    <div ref={ref} className={`overflow-hidden ${className}`}>
      <motion.img
        src={src}
        alt={alt}
        style={{ y, scale: 1 + speed * 2.4 }}
        className="h-full w-full object-cover will-change-transform"
        loading={eager ? "eager" : "lazy"}
        decoding="async"
      />
    </div>
  );
};

export const Marquee = ({ items, dark = false }) => (
  <div
    className={`overflow-hidden border-y py-8 md:py-10 ${
      dark ? "border-ivory/10 bg-ink text-ivory/25" : "border-ink/10 bg-ivory text-ink/20"
    }`}
    aria-hidden="true"
  >
    <div className="animate-marquee flex w-max whitespace-nowrap">
      {[0, 1].map((dup) => (
        <div key={dup} className="flex shrink-0">
          {items.map((item, i) => (
            <span key={i} className="flex items-center font-serif text-3xl font-light italic md:text-5xl">
              <span className="px-8 md:px-12">{item}</span>
              <span className="h-1.5 w-1.5 rotate-45 bg-bronze/70" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
